import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selectContainer", "manualContainer", "selectField", "manualField", "selectButton", "manualButton"]

  connect() {
    // Default to select mode when orders are available
    this.showSelect()
  }

  showSelect() {
    if (!this.hasSelectContainerTarget) return

    this.selectContainerTarget.classList.remove("hidden")
    this.manualContainerTarget.classList.add("hidden")

    // Update button styles
    this.selectButtonTarget.style.backgroundColor = "var(--color-primary)"
    this.selectButtonTarget.style.color = "white"
    this.manualButtonTarget.style.backgroundColor = "var(--color-neutral)"
    this.manualButtonTarget.style.color = "var(--color-text)"

    // Clear manual field and enable select field
    if (this.hasManualFieldTarget) {
      this.manualFieldTarget.value = ""
      this.manualFieldTarget.removeAttribute("name")
    }
    if (this.hasSelectFieldTarget) {
      this.selectFieldTarget.setAttribute("name", "refund_request[order_number]")
    }
  }

  showManual() {
    if (!this.hasManualContainerTarget) return

    this.manualContainerTarget.classList.remove("hidden")
    this.selectContainerTarget.classList.add("hidden")

    // Update button styles
    this.manualButtonTarget.style.backgroundColor = "var(--color-primary)"
    this.manualButtonTarget.style.color = "white"
    this.selectButtonTarget.style.backgroundColor = "var(--color-neutral)"
    this.selectButtonTarget.style.color = "var(--color-text)"

    // Clear select field and enable manual field
    if (this.hasSelectFieldTarget) {
      this.selectFieldTarget.value = ""
      this.selectFieldTarget.removeAttribute("name")
    }
    if (this.hasManualFieldTarget) {
      this.manualFieldTarget.setAttribute("name", "refund_request[order_number]")
    }
  }
}
